var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchiveTaskIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 60,
    viewBox: "0 0 49 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7998 30.0002V27.2002",
    stroke: "#48CDAA",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7998 46.8002V41.2002",
    stroke: "#48CDAA",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7998 16.0002V13.2002",
    stroke: "#48CDAA",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30 2V13.2C30 14.6852 30.59 16.1096 31.6402 17.1598C32.6904 18.21 34.1148 18.8 35.6 18.8H46.8",
    stroke: "#48CDAA",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2 58H41.2C42.6852 58 44.1096 57.41 45.1598 56.3598C46.21 55.3096 46.8 53.8852 46.8 52.4V16L32.8 2H7.6C6.11479 2 4.69041 2.59 3.6402 3.6402C2.59 4.69041 2 6.11479 2 7.6V52.4C2.0002 53.3941 2.265 54.3701 2.7672 55.228",
    stroke: "#48CDAA",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8002 57.9998C21.893 57.9998 24.4002 55.4926 24.4002 52.3998C24.4002 49.307 21.893 46.7998 18.8002 46.7998C15.7074 46.7998 13.2002 49.307 13.2002 52.3998C13.2002 55.4926 15.7074 57.9998 18.8002 57.9998Z",
    stroke: "#48CDAA",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchiveTaskIcon);
export default __webpack_public_path__ + "static/media/ArchiveTaskIcon.0451981782fc7528da5442715d53c82b.svg";
export { ForwardRef as ReactComponent };